import { render, staticRenderFns } from "./TrainingFilesEditor.vue?vue&type=template&id=2e2777ec&scoped=true"
import script from "./TrainingFilesEditor.vue?vue&type=script&lang=js"
export * from "./TrainingFilesEditor.vue?vue&type=script&lang=js"
import style0 from "./TrainingFilesEditor.vue?vue&type=style&index=0&id=2e2777ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2777ec",
  null
  
)

export default component.exports